export default __webpack_public_path__ + "static/preview-aacde7ab294d619fdcd90efa7a8d2c05.png";